import { useState } from 'react'
import classNames from 'classnames'

import { FileIconPlaceholder, FileIconType } from '../../FileIcon'
import { ICON_HEIGHT_44 } from '../../Icon'
import { FilePreviewImage } from '../FilePreviewImage'

import { FILE_PREVIEW_VIDEO_ICON_PLAY_ID } from './FilePreviewVideo.constants'

import * as styles from './FilePreviewVideo.module.css'

function FilePreviewVideo({
  children,
  className,
  data,
  disabled,
  iconSize = ICON_HEIGHT_44,
  onClick,
  ...restProps
}) {
  const { name, origin, preview } = data

  const [hasError, setError] = useState(false)

  function handleError() {
    return setError(true)
  }

  return (
    <div
      className={classNames(styles.video, { [styles.disabled]: disabled })}
      onClick={onClick}
    >
      <FilePreviewImage
        {...restProps}
        alt={name}
        className={className}
        src={preview || origin}
        onError={handleError}
      >
        {children}
      </FilePreviewImage>
      {!hasError ? (
        <FileIconPlaceholder
          className={styles.play}
          iconProps={{ id: FILE_PREVIEW_VIDEO_ICON_PLAY_ID }}
          size={iconSize}
          type={FileIconType.Play}
        />
      ) : null}
    </div>
  )
}

export default FilePreviewVideo
